import Favicon from "assets/images/favicon.ico";


export const companyDetails = {
    companyName: "ITER-Consumer",
    favicon: Favicon,
}